import crypto from 'crypto';
import { atob, btoa } from "../helpers";

/**
 * Generates a version hash based on the provided data and date.
 *
 * @param {string} data - The data to be hashed.
 * @param {string} date - The date to be included in the hash.
 * @returns {string} - The generated version hash encoded in base64.
 */
const generateVersionHash = (data = '', date = '') => {
  const secret = atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3));
  const hash = crypto.createHash('sha256');
  hash.update(data + date + secret);
  return btoa(hash.digest('hex'));
};

export default generateVersionHash;